// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTAVersion } from './dta-version';
import {
    DTAVersionFromJSON,
    DTAVersionFromJSONTyped,
    DTAVersionToJSON,
    DTAVersionToJSONTyped,
} from './dta-version';

/**
 * 
 * @export
 * @interface DTAVersionsResponse
 */
export interface DTAVersionsResponse {
    /**
     * 
     * @type {number}
     * @memberof DTAVersionsResponse
     */
    count: number;
    /**
     * 
     * @type {Array<DTAVersion>}
     * @memberof DTAVersionsResponse
     */
    versions: Array<DTAVersion>;
}

/**
 * Check if a given object implements the DTAVersionsResponse interface.
 */
export function instanceOfDTAVersionsResponse(value: object): value is DTAVersionsResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('versions' in value) || value['versions'] === undefined) return false;
    return true;
}

export function DTAVersionsResponseFromJSON(json: any): DTAVersionsResponse {
    return DTAVersionsResponseFromJSONTyped(json, false);
}

export function DTAVersionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTAVersionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'versions': ((json['versions'] as Array<any>).map(DTAVersionFromJSON)),
    };
}

export function DTAVersionsResponseToJSON(json: any): DTAVersionsResponse {
    return DTAVersionsResponseToJSONTyped(json, false);
}

export function DTAVersionsResponseToJSONTyped(value?: DTAVersionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'versions': ((value['versions'] as Array<any>).map(DTAVersionToJSON)),
    };
}
